export default {
  Fleet_Phase3_Other_mKWz: 'Other',
  Fleet_check_hceA_ycnc: 'Got It',
  Fleet_Phase2_Unable_to_ZEyJ:
    'Unable to send invite. This vehicle has already been linked to another driver',
  Fleet_Phase1_Refresh_successfully_sWTn:
    'Vehicle status refreshed. Your vehicle will be shown to more drivers',
  Fleet_NewPaymentFlow__GUTP: 'One-time Fee',
  Fleet_NewPaymentFlow__NhvB:
    'Amount: {{Price}}. Charged from: {{begin_datetime}}. Frequency: {{Frequency}}.',
  Fleet_check_fBNK_CTjZ: 'You can only invite drivers after your profile photo is approved.',
  Fleet_Phase3__eugX: 'Please enter detailed address',
  Fleet_Phase1_My_information_gZpd: 'My Profile',
  Fleet_Phase1_Management_laKS: 'Management',
  Fleet_Phase2_Unable_to_DjsM: 'Unable to send invite. Please try again later',
  Fleet_Phase2_Not_read_oNht: 'Unread',
  Fleet_Phase2_Invitation_binding_pNPg: 'Invite',
  Fleet_NewPaymentFlow__qyoQ:
    '{{Expenses_type}} will be automatically deducted from your Wallet. Frequency: {{Frequency}}.',
  Fleet_Phase3__HBGE: 'Search address',
  Fleet_Phase1__day_TSlN: '{{day_num}} day(s)',
  Fleet_Phase2_Here_is_UUpu: 'Please take a look at my resume',
  Fleet_Phase1_Please_select_sHdy: 'Please select at least one',
  Fleet_Phase3__YASB: 'Address Details',
  Fleet_Phase1_Completed_lnTq: 'Filled in',
  Fleet_Phase1_Select_from_vFPP: 'Select from Album',
  Fleet_Phase2_Invitation_accepted_jUWV: 'Invite accepted',
  Fleet_NewPaymentFlow_TSCH_mgfl:
    'You’ll need to collect rental fees and other expenses from the driver offline',
  Fleet_6_Approved_iJNK: 'Approved',
  Fleet_Phase2_Select_a_IWnZ: 'Please select a vehicle',
  Fleet_Phase3__NQtB: 'Not approved',
  Fleet_Phase1_Want_FfcG: 'Wants',
  Fleet_NewPaymentFlow_svTo_tbpj: 'To change the collection method, please go to Me > Settings',
  Fleet_Phase3_When_it_VfVv:
    'When enabled, fleet partners can see your info and contact you. When disabled, fleet partners cannot see your info.',
  Fleet_Phase1_Vehicle_Information_GKvX: 'Vehicle Profile',
  Fleet_Phase1_Near_wiMy: 'Nearby',
  Fleet_replenish__AsrC: 'Please enter fleet nickname',
  Fleet_Phase2_Unable_to_rFbW: 'Unable to send invite. You have already invited this driver',
  Fleet_Phase3_Please_fill_TwPJ: 'Please enter a one-time fee type',
  Fleet_NewPaymentFlow__JGoj: 'Collection Method',
  Fleet_Phase3_Cancel_lhJc: 'Cancel',
  Fleet_Phase2_Sent_successfully_VMHB: 'Sent successfully',
  Fleet_Phase1_Unfilled_information_shzk: 'Please fill in all required fields',
  Fleet_Phase1_Refresh_vehicle_dBKn: 'Refresh vehicle status to attract more views',
  Fleet_Phase1_Petrol_xPTk: 'Gas',
  Fleet_NewPaymentFlow__Wzlo: 'Set up rental fees and other expenses',
  Fleet_MatchingTool_Loading_ingu: 'Loading',
  Fleet_Phase1_Select_the_TBEO: 'Select the earliest available date',
  Fleet_Phase1_Pick_up_Fzqt: 'Vehicle Pickup Address',
  Fleet_Phase3_Maintenance_costs_Arun: 'Maintenance Fee',
  Fleet_Phase3_Looking_for_mjCy: 'Search',
  Fleet_Phase2_Go_and_TKGq: 'Enter Now',
  Fleet_NewPaymentFlow_lHPn_FNIg: 'Please enter an expense name',
  Fleet_Phase3_Fill_in_AwVF: 'Tell drivers about you and the services you provide',
  Fleet_Phase3_Handling_address_Kuoh: 'Manage Vehicle Pick-up Address',
  Fleet_Phase1_Successfully_removed_Kfwm: 'Removed successfully',
  Fleet_Phase3_To_protect_LYnV:
    'For privacy reasons, a virtual number will be used for this call. Please call using {{phone_num}}.',
  Fleet_Phase2_Delete_OMUs: 'Remove',
  Fleet_Phase2_You_have_VdTt: 'Invite accepted. Please contact the Fleet to rent a vehicle',
  Fleet_Phase1_Successful_collection_cgRX: 'Added to Favorites',
  Fleet_Phase3_Allowing_for_dpCi: 'Make My Info Public',
  GDriver_Name_99_mpNh: '99',
  Fleet_Phase1_Driving_age_CGrZ: 'Driving Experience',
  Fleet_Phase1_Recommended_JWJE: 'Recommended',
  Fleet_Phase1_Yes_KnFJ: 'Yes',
  Fleet_replenish__Nkhy: 'Unable to add',
  Fleet_Phase1_There_are_TYqj: 'Find skilled drivers here',
  Fleet_Phase2_Waiting_for_CtmY: 'Awaiting response from driver',
  Fleet_Phase1_Select_the_arPR: 'Select Default Images',
  Fleet_Phase2_Unable_to_mzyp:
    'Unable to accept invite. You have already been added by another Fleet',
  Fleet_Phase3__xiYg: 'Download {{app_name}} App',
  Fleet_Phase1_Edit_bifa: 'Edit',
  Fleet_Phase2_Confirmation_Amgz: 'Confirm',
  Fleet_Phase1_Inactive_vehicles_oKjt: 'Idle',
  Fleet_Phase3__RlYg:
    'Image requirements not met. Remove invalid image and upload actual photo of your vehicle',
  Fleet_Phase1_Vehicle_market_bycj: 'Find Vehicles',
  Fleet_Phase1_You_modified_ugEp: 'Your edits are not saved. Are you sure you want to exit?',
  Fleet_Phase2_The_message_dvIE: 'Message is too long. Try shortening it',
  Fleet_Phase1_Types_of_Dcxe: 'Available Services',
  Fleet_Phase3__sjZr: 'Enable Now',
  Fleet_Phase2_Open_message_BjYw:
    'To receive messages and all the latest updates, please enable Notification Permissions',
  Fleet_Phase2_Sending_vehicles_VpWK: 'Send Vehicle',
  Fleet_NewPaymentFlow__GCoA: 'Effective Date',
  Fleet_Phase1_On_the_Zuml: 'Added',
  Fleet_Phase1_Recommended_tZZU: 'Recommended',
  Fleet_Phase3_Looking_for_VBig: 'Search',
  Fleet_Phase1_Countless_counts_rEma: 'No data available',
  GDriver_Name_DiDi_Gsik: 'DiDi',
  Fleet_Phase1_Open_the_mLYO:
    'Please go to Settings > Privacy > Location Services, and allow {{app_name}} Fleet to use Location Services',
  Fleet_Phase3_Select_KUZn: 'Featured',
  Fleet_Phase3_The_driver_lmIm: 'Drivers will contact you using your actual number',
  Fleet_Phase1_Please_enter_kMFd: 'Please enter your phone number',
  Fleet_Phase2_More_features_rGBL: 'Tap here for more features',
  Fleet_deactivation_rxsN_avVX: 'This vehicle was removed',
  Fleet_Phase1_Vehicter_vehicles_KaSk: 'Add Vehicle',
  Fleet_Phase1_Fill_in_kRws:
    'Please enter your personal details to help the Fleet learn about and contact you',
  'kfcommon-fe-i18n---common': {
    inpPlease: 'please fill'
  },
  Fleet_EContract_Email_mdfN: 'Email',
  Fleet_Phase1_Later_aaAa: 'Maybe Later',
  Fleet_Resdesign_Enter_email_cylU: 'Enter email',
  Fleet_Phase1_Management_Kglv: 'Management',
  Fleet_Phase1_Driver_Market_lUUD: 'Find Drivers',
  Fleet_Phase3_Add_pickup_rHID: 'Add Address',
  Fleet_Phase1_The_earliest_BMcv: 'Earliest Available Time',
  Fleet_FleetRecommendation_Enter_the_Ykpv: 'Please enter a valid amount',
  Fleet_Phase1_Vehicter_vehicles_cgyn: 'Add Vehicle',
  Fleet_Phase1_Editing_your_VLmr: 'Edit Resume',
  Fleet_Phase1_Add_a_ZZNX: 'Add New Vehicle',
  Fleet_Phase1_Lower_vehicle_gEAa: 'Remove Vehicle',
  Fleet_Phase1_Are_mileage_hsVk: 'Is there a limit on mileage?',
  Fleet_Phase1_Add_other_TKWp: 'Add Other One-time Fees',
  Fleet_NewPaymentFlow__ZQOF: 'Next',
  Fleet_Phase2_Invitation_expired_IedS: 'Invite expired',
  Fleet_Phase1_The_driver_Ktpo:
    'Drivers will call you via a virtual number. They will not see your real number',
  Fleet_Phase2_You_might_PnzM: 'You might want to',
  Fleet_Phase1_Enter_the_CVAP: 'Please enter the vehicle’s mileage',
  Fleet_Phase2_Cancel_UgrT: 'Cancel',
  Fleet_NewPaymentFlow__AMrP:
    'You’ll need to collect rental fees and other expenses from the driver offline',
  Fleet_Phase2_Your_resume_VFPE: 'Complete your resume',
  Fleet_Phase1_Do_you_jEQf: 'Do you have a parking space?',
  Fleet_Phase1_Open_Location_yZxu: 'Enable Location Permissions',
  Fleet_deactivation_ZMOT_xRGi: 'These vehicle(s) were removed:',
  Fleet_Phase2__Invite_AtyZ: '[Invited you to join their fleet]',
  Fleet_Phase1_Automatic_file_EBVQ: 'Automatic',
  Fleet_0303_Fleet_WorkRegime_Withdrawal_oCRI: 'Driver Withdrawal',
  Fleet_Phase1_Waiting_for_hAcD: 'Not Added Yet',
  Fleet_Mgt_Pull_down_YzpV: 'Pull down to refresh',
  Fleet_Phase1_Cities_with_FYWy: 'Service City',
  Fleet_NewPaymentFlow__TkSG: 'Contact Fleet',
  Fleet_Phase1_Select_vehicle_eTyy: 'Select Vehicle',
  Fleet_Phase1_Weekly_rent_Qcao: 'Weekly rental fee',
  Fleet_NewPaymentFlow_sKlJ_uHRX: 'Expense {{num}}',
  Fleet_Phase2_Accept_the_SSyv: 'Invite accepted',
  Fleet_Phase1_Upload_vehicle_CJxH: 'Please upload vehicle photos',
  Fleet_Phase3_Insurance_UelD: 'Insurance Fee',
  Fleet_Phase1_Open_positioning_isUK:
    'Enabling location permissions will allow you to view more information',
  Fleet_Phase3_Delete_isuY: 'Delete',
  Fleet_Phase3_Select_city_OuhR: 'Please select a city',
  Fleet_Phase1_No_somg: 'No',
  Fleet_Phase2__picture_dcAZ: '[Image]',
  Fleet_NewPaymentFlow__aQyj: 'Add Other Expenses',
  Fleet_Phase2_Can_t_Ypzr: 'Unable to send a blank message',
  Fleet_Phase1_Lease_Information_AcRo: 'Rental Info',
  Fleet_Phase2_Fill_in_HjMn: 'Enter your resume details to help the Fleet learn about you',
  Fleet_Phase1_Electric_OCNq: 'Electric',
  Fleet_check_pajT_vPwq: 'Please Upload a Profile Photo',
  Fleet_Phase1_Confirmation_hXpq: 'Confirm',
  Fleet_Phase3__ZyyO: 'Are you sure you want to exit?',
  Fleet_Phase3__ZGux: 'Download {{brand_name}} App',
  Fleet_Phase1_Go_on_lQWv: 'Enable Now',
  Fleet_Phase2_Are_you_tmbn: 'Are you sure you want to accept this invite?',
  Fleet_0303_Fleet_WorkRegime_Car_front_XMgw: 'Driver Reward Paid by Fleet',
  Fleet_Phase2_Upon_acceptance_RppA:
    'If you accept, you’ll join the fleet and link the vehicle shown. To leave, please contact the Fleet.',
  Fleet_Phase1_Display_MPQk: 'Displays',
  Fleet_Phase2_Send_your_boUl: 'Send Resume',
  Fleet_NewPaymentFlow__upZL: 'Expense Type',
  Fleet_Phase3_Agree_GpZc: 'Accept',
  Fleet_Phase2_Are_you_pyUy:
    'Unmatch with this driver? Once unmatched, you won’t receive messages from them',
  Fleet_Phase1_Location_hZax: 'Location',
  Fleet_Phase1_My_resume_XrBM: 'My Resume',
  Fleet_NewPaymentFlow__ZwVw: 'Expenses will become effective starting on {{Effective_date}}',
  Fleet_Phase1_Introduce_more_wgzd: 'Add more info about the vehicle to help rent it out faster',
  Fleet_Phase2_Unable_to_BjVG:
    'Unable to accept invite. You have already been invited by another Fleet',
  Fleet_Phase1_Boleto_FURd: 'Boleto',
  Fleet_NewPaymentFlow_CAbk_WnqE:
    'Rental fees and other expenses will be collected automatically from the driver’s Wallet. If they don’t have sufficient balance, you’ll need to collect the rest from the driver offline',
  Fleet_Phase3__wuiT: 'Cancel',
  Fleet_Phase3__cGjU: 'Send',
  Fleet_Phase2_Latin_America_mcWa: 'Unmatch',
  Fleet_Phase1_Open_the_qftm:
    'Please go to Settings > Privacy > Notifications, and allow {{app_name}} Fleet to use Notifications',
  Fleet_Mgt_Loosen_immediately_OZaY: 'Release to refresh',
  Fleet_Phase2_The_invitation_cRjb:
    'Invite expired. Please ask the Fleet to send the invite link again',
  Fleet_MatchingTool_New_NygE: 'New',
  Fleet_Phase2_Message_uxVI: 'Messages',
  Fleet_Phase1_Mileage_Nbsu: 'Mileage',
  Fleet_Phase1_Select_a_MUGc: 'Please select the service city',
  Fleet_Phase3__aLzi: 'Search license plate no. / model',
  Fleet_Phase3_Disapproval_WwYC: 'Decline',
  Fleet_Phase1_Saved_ukpW: 'Favorite',
  Fleet_Phase1_Near_GlZf: 'Nearby',
  Fleet_Phase1_Fill_in_SDNM: 'Fill In Now',
  Fleet_NewPaymentFlow__GiSP: 'Effective Date',
  Fleet_0303_Fleet_WorkRegime_Rental_fares_pUsF: 'Vehicle Rental',
  Fleet_Phase2_Camera_xPcX: 'Camera',
  Fleet_Phase1_Contact_the_sCYy: 'Contact Driver',
  Fleet_tool_HivM_XeKG:
    'Please consider the reliability of information received from outside the {{brand_name}} platform and beware of false information.',
  Fleet_Phase1__trip_OWdz: '{{trip_num}} trip(s)',
  Fleet_Phase3_Set_ozBm: 'Settings',
  Fleet_Phase1_Vehicles_fail_vWFT: 'Unable to add vehicle. Please try again later',
  Fleet_Phase1_Credit_card_nkHX: 'Credit card',
  Fleet_replenish__YWZk: 'Fleet Nickname',
  Fleet_NewPaymentFlow__vurJ:
    'Automatic Collection: Rental fees and other expenses will be deducted automatically from your Wallet. If your balance is insufficient, you’ll need to pay the rest to the fleet partner offline',
  Fleet_Phase1_Vehicle_mileage_JJmR: 'Vehicle’s Mileage',
  Fleet_Phase2_I_m_otcY: 'I’m interested in your vehicle. Can we chat about it?',
  Fleet_deactivation_vcXF_nzJK: 'These inquired vehicle(s) were removed:',
  Fleet_NewPaymentFlow__ltIu:
    'Rental fees and other expenses will be collected automatically from the driver’s Wallet. If they don’t have sufficient balance, you’ll need to collect the rest from the driver offline',
  Fleet_NewPaymentFlow__cGLW:
    'Please note that after you accept an invitation and successfully join a fleet, the fleet partner will be able to add or edit an expense without further confirmation from you.',
  Fleet_Phase3_Contact_number_gTtI: 'Contact Number',
  Fleet_Drivers_Amount_YOtw: 'Amount',
  Fleet_Phase3_Urban_upMp: 'City',
  Fleet_NewPaymentFlow__wclB:
    'Please read and confirm the rental fees and other expenses info. Tap Accept to join the fleet',
  Fleet_Phase1_Select_the_DRmS: 'Please select a transmission type',
  Fleet_Phase2_Album_HNuC: 'Album',
  Fleet_Phase3_Would_you_XJNH: 'Are you sure you want to delete this address?',
  Fleet_check_IYER_eDig:
    'You can only link vehicles to drivers in your fleet after your profile photo is approved.',
  Fleet_Phase3__wCFx: 'Uploaded',
  Fleet_check_PFze_fown: 'Profile Photo Review in Progress',
  Fleet_Phase1_Reset_ZyNB: 'Reset',
  Fleet_NewPaymentFlow__BFLZ: 'Next',
  Fleet_Phase1_Edit_IQWQ: 'Edit',
  Fleet_Phase1_Browse_HIWC: 'Views',
  Fleet_Phase1_Payment_Method_fVJF: 'Preferred Payment Method',
  Fleet_Phase1_Click_Change_LCrQ: 'Tap to Change',
  Fleet_Phase3_Cancel_flmb: 'Cancel',
  Fleet_NewPaymentFlow_OSHq_PQkz: 'Please select a vehicle',
  Fleet_replenish__dJdA: 'System error. Please try again',
  Fleet_Phase1_Next_step_OMuQ: 'Next',
  Fleet_NewPaymentFlow__ydGV: 'Rental Info',
  Fleet_Phase1_Star_rating_jYxN: 'Star Rating',
  Fleet_Phase2_Unable_to_ylbx: 'Unable to accept invite. This vehicle has already expired',
  Fleet_Phase2_Confirmation_JNjK: 'Confirm',
  Fleet_Phase1_Payment_Method_wZPV: 'Payment Method',
  Fleet_check_OZWz_BEqb: 'Upload Now',
  Fleet_replenish__ZOFV: 'Unable to call. Please try again',
  Fleet_Phase3_Other_jpBw: 'Other',
  Fleet_Phase1_Unable_to_LSII: 'Unable to get notification permission',
  Fleet_Phase1_Model_tdll: 'Model',
  Fleet_NewPaymentFlow__yzdB: 'Vehicle Details',
  Fleet_Phase3_Unable_to_pVKf: 'Unable to call. Please try again',
  Fleet_Phase3_Set_to_rSJK: 'Set as Default Pickup Address',
  Fleet_Phase1_Add_your_cKWv: 'Show your vehicle to drivers who are looking to rent one',
  Fleet_Phase3__CXxw: 'Location services are disabled',
  Fleet_Phase2_View_Details_MBZa: 'View Details',
  Fleet_Phase1_Type_of_YmjW: 'Energy Type',
  Fleet_Phase3__gvnI: 'No results found',
  Fleet_NewPaymentFlow__QXtF: 'Monthly',
  Fleet_Mgt_No_more_mlms: 'No more to view',
  Fleet_Phase1_Successful_shelves_roWu: 'Added successfully',
  Fleet_Phase2_Unable_to_UqWk:
    'Unable to send invite. This driver has already been added by another Fleet',
  Fleet_Phase1_Weekly_online_gZHC: 'Weekly Hours Online',
  Fleet_Phase2_Accept_the_RiKY: 'Accept Invite',
  Fleet_FleetRecommendation_Contact_number_yTBC: 'Contact Number',
  Fleet_Phase3_Public_number_KRCc: 'Show My Number',
  Fleet_Phase1_Introduce_more_WZRj: 'Tell us more about yourself to help the Fleet learn about you',
  Fleet_Phase1_Add_a_QLhS: 'Add Resume',
  Fleet_Phase1_Refresh_iWvD: 'Refresh',
  Fleet_Phase1_Enter_the_LXDS: 'Please enter your name',
  Fleet_Phase1_Go_and_ddqt: 'Enter Now',
  Fleet_deactivation_pIlV_dzGd: 'This vehicle will be removed soon',
  Fleet_Phase3__XowH: 'Are you sure you want to send the email?',
  Fleet_Phase3__Gfwg: 'Uploading',
  Fleet_Phase1_Hand_gear_hAFe: 'Manual',
  Fleet_NewPaymentFlow__PRyq: 'Daily',
  Fleet_Phase1_Enter_the_tbQJ: 'Please enter an amount',
  Fleet_check_Admw_cABo: 'Not Now',
  Fleet_Phase2_Contact_the_xIkV: 'Contact Fleet',
  Fleet_Phase2_Action_ZSsi: 'Choose an option',
  Fleet_NewPaymentFlow__Khbs: 'Automatic',
  Fleet_Phase1_Diesel_rsEa: 'Diesel',
  Fleet_Phase2_Call_yqck: 'Call',
  Fleet_Phase1_Other_tQVW: 'Other',
  Fleet_Phase1_Collection_XqMI: 'Favorite',
  Fleet_Phase1_Personal_information_rOpp: 'Personal Details',
  Fleet_Phase1_Default_image_AFLD: 'Default Images',
  Fleet_Phase1_Vehicle_photos_CWvR: 'Vehicle Photos',
  Fleet_Phase1_Add_more_ykcL: 'Add more info about the vehicle to help rent it out faster',
  Fleet_Drivers_Save_feyd: 'Save',
  Fleet_Phase1_Go_vwbQ: 'Go',
  Fleet_Phase2_Send_UCas: 'Send',
  Fleet_Phase3_Offences_Eyzh: 'Traffic Violation Fee',
  Fleet_Phase1_Price_JEDD: 'Price',
  Fleet_Phase1_Confirmation_and_UFnR: 'Confirm and Add',
  Fleet_Phase1_Add_a_yEOo: 'Add vehicle photos to help rent out your vehicle faster',
  Fleet_Phase2_Waiting_for_PGxV: 'Awaiting response',
  Fleet_Phase1_Select_model_MskT: 'Please select a vehicle type',
  Fleet_Phase3_Pick_up_fDQC: 'Vehicle Pickup Address',
  Fleet_Phase2_Your_vehicle_etii:
    'Your vehicle {{Vehicle_Plate}} didn’t pass review. Please submit required info and add again',
  Fleet_Phase2_Select_vehicle_DmgM: 'Select a Vehicle',
  Fleet_Phase2_Don_t_fbDU: 'Don’t want to miss any messages / updates?',
  Fleet_Phase3__yPol: 'For your privacy, drivers won’t see your full address',
  Fleet_Phase3_Show_Name_DTSP: 'Name Shown',
  Fleet_Phase1_Rental_gIKm: 'Rental Fee',
  Fleet_Phase1_No_idle_CWLj: 'No idle vehicles available',
  Fleet_Phase2_I_think_iJfP:
    'I think my vehicle might meet your requirements. Can we chat about it?',
  Fleet_Phase1_Cancel_the_jVMw: 'Removed from Favorites',
  Fleet_Phase1_Week_DoYO: 'week',
  Fleet_0303_Fleet_WorkRegime_Driver_Recharge_jdnd: 'Driver Refill',
  Fleet_NewPaymentFlow__bEhi:
    'Rental fees and other expenses will be automatically deducted from your Wallet',
  Fleet_NewPaymentFlow_kWOv_gcBa: 'Please select',
  Fleet_deactivation_IDBa_Nsnf: 'This vehicle was removed',
  Fleet_v2_Successfully_saved_SuWc: 'Saved successfully',
  Fleet_Phase1_Transmission_box_ntTQ: 'Transmission',
  Fleet_Phase1_Select_Energy_jPEr: 'Please select an energy type',
  Fleet_Phase1_shelves_gQRG: 'Add to Market',
  Fleet_FleetRecommendation_Enter_the_OAao: 'Please enter a valid phone number',
  Fleet_NewPaymentFlow__EBXA:
    'Offline Collection: You will need to pay rental fees and other expenses to the fleet partner offline',
  Fleet_NewPaymentFlow__xLMz:
    'Rental fees and other expenses will need to be settled with the fleet partner offline',
  Fleet_Phase2_Invitation_to_XuMK: 'Invite',
  Fleet_Phase1_Delete_vHOi: 'Delete',
  Fleet_Phase2__CV_ufBg: '[Resume]',
  Fleet_Phase1_The_vehicle_iveG: 'Vehicle is linked to a driver. Please unlink driver and retry',
  Fleet_Phase3_No_pickup_yaXi: 'No addresses added yet',
  Fleet_Phase2_Get_a_ViuM: 'Get Resume',
  Fleet_Phase1_Star_rating_LMKh: 'Star Rating',
  Fleet_NewPaymentFlow__TGeN: 'Expense Collection Method',
  Fleet_0303_Fleet_WorkRegime_drawn_front_MIbK: 'Fleet 0% Commission Card Purchase',
  Fleet_Phase1_Energy_PPWp: 'Energy',
  Fleet_Phase1_More_information_QGAV: 'More Info',
  Fleet_Phase2_Unable_to_Mpfg: 'Unable to send invite. This driver has been suspended',
  Fleet_Phase1_Exit_olZc: 'Exit',
  Fleet_Phase1_Other_ydLJ: 'Other',
  Fleet_Phase2_All_BQZQ: 'All',
  Fleet_Phase1_Please_select_XUaB: 'Please select available services',
  Fleet_Phase3_Call_now_MEMz: 'Call Now',
  Fleet_Phase2_Your_vehicle_Rmil: 'Your vehicle {{Vehicle_Plate}} was added',
  Fleet_Phase1_Home_Page_ezjA: 'Homepage',
  Fleet_check_XKad_fPlI: 'Please Re-Upload Profile Photo',
  Fleet_Phase2_Are_you_uNIJ: 'Are you sure you want to remove this chat from the list?',
  Fleet_0303_Fleet_WorkRegime_Car_wash_XdSy: 'Cleaning Fee',
  Fleet_Phase1__One_ZBrR: '(One-time fee)',
  Fleet_Phase1_It_s_wzyX: 'No more data',
  Fleet_Phase3__cYdF: 'Go to Document Review',
  Fleet_Phase1_The_vehicle_cZTB: 'This vehicle was removed. Please add it again',
  Fleet_Phase1_Take_a_SlkQ: 'Take Photos',
  Fleet_report_Division_Information_capz: 'Driver Info',
  Fleet_NewPaymentFlow__OEob:
    '{{Expenses_type}} will be deducted from your Wallet with a one-time payment',
  Fleet_Phase3_Hidden_Number_tNmI: 'Hide My Number',
  Fleet_Phase1_My_message_SfLZ: 'My Info',
  Fleet_Phase3__jxmA: 'Email Address',
  Fleet_NewPaymentFlow__BevI: 'Weekly',
  Fleet_Phase2_I_invite_jgxW: 'You’re invited to join my fleet',
  Fleet_Phase1_Mixed_aWEq: 'Hybrid',
  Fleet_0303_Fleet_WorkRegime_Other_items_zPbu: 'Other',
  Fleet_0303_Fleet_WorkRegime_Oil_PGEr: 'Refueling Fee',
  Fleet_Phase2__Fleet_RTrK: '{{Fleet_Name}} invited you to join their fleet',
  Fleet_Phase1_Upload_your_NZFc: 'Please upload vehicle documents',
  Fleet_0303_Fleet_WorkRegime_lease_fee_hIok: 'Phone Rental',
  Fleet_Phase3__xZGP: 'Review Result',
  Fleet_Phase2__Vehicle_mAIO: '[Vehicle {{Vehicle_Model}}]',
  Fleet_Phase3__lTOd: 'Documents not uploaded or didn’t pass review',
  Fleet_Phase1_The_driver_pCZd: 'Drivers can contact you directly via this email address',
  Fleet_Phase3_User_Services_wNXe: 'Terms and Conditions',
  Fleet_NewPaymentFlow__tgtT: 'Rental Fee',
  Fleet_Phase3_GNV_amUx: 'GNV',
  Fleet_Phase3_Integrated_sorting_uksd: '',
  Fleet_Phase3_Deposit_TMrZ: 'Deposit',
  Fleet_NewPaymentFlow_mzMZ_ChLK: 'Please enter',
  Fleet_Drivers_Go_Settings_vpjg: 'Setup',
  Fleet_Phase2_Open_notification_kirV: 'Enable Notification Permissions to get messages & updates',
  Fleet_Phase1_Message_iuXA: 'Messages',
  Fleet_Phase2_Unable_to_jWPV: 'Unable to accept invite. Please first complete the document review',
  Fleet_Phase1_Year_uoao: 'year(s)',
  Fleet_Phase1_Cancel_JTqC: 'Cancel',
  Fleet_Phase3_Unable_to_nWie: 'Unable to add',
  Fleet_Phase1_Idle_GiMD: 'Idle time',
  Fleet_Phase3__LovJ: 'Exit',
  Fleet_Phase1_Oil_to_UJTc: 'Oil-to-gas',
  Fleet_Phase1_You_can_zwFo: 'You can also add idle vehicles',
  Fleet_Phase1_Single_amount_mreo: 'Trips',
  Fleet_MatchingTool_Confirmation_sFAu: 'OK',
  Fleet_check_uiYb_OxPW:
    'Your profile photo was declined {{reject_max_time}} times. To use this feature, please upload a valid photo and wait for approval.',
  Fleet_Phase3_Cost_type_DhmU: 'Fee Type',
  Fleet_Phase1_Select_one_YoKe: 'Please select one',
  Fleet_NewPaymentFlow__BVvn: 'Offline',
  Fleet_Phase3_Coming_up_Vjsn: 'This call will be encrypted',
  Fleet_MatchingTool_Cancel_Wqtt: 'Cancel',
  Fleet_FMS_Verification_failed_dRqq: 'Not Approved',
  Fleet_Phase2_Driver_Message_UxZf: 'Driver Messages',
  Fleet_Phase1_Mileage_in_vScJ: 'Mileage',
  Fleet_NewPaymentFlow__Mhyi: 'Delete',
  vehicle_info: 'Vehicle Information',
  small: 'The image must be less than 3 MB'
};
